<script>
import { hoursToIntervals } from '@/utils';

const getText = hours => {
  const intervals = hoursToIntervals(hours);
  let result = '';

  if (intervals.years) {
    result += `${intervals.years}г `;
  }
  if (intervals.months) {
    result += `${intervals.months}м `;
  }
  if (intervals.days) {
    result += `${intervals.days}д `;
  }
  if (intervals.hours) {
    result += `${intervals.hours}ч `;
  }
  if (intervals.minutes) {
    result += `${intervals.minutes}мин `;
  }

  if (!result) {
    return '0ч';
  }

  return result;
};

export default {
  functional: true,
  props: {
    hours: {
      type: Number,
      required: true,
    },
  },
  render (h, context) {
    return (
      <span>
        {getText(context.props.hours)}
      </span>
    );
  },
};
</script>
